import {Injectable, Injector} from '@angular/core';
import {ListService} from '@shared/models/list-service.model';
import {Observable} from 'rxjs/Rx';
import {DossierList} from '../models/dossier-list.model';
import {OperationsFilterModel} from '../models/operations-filter.model';
import {DossierAttachment, DossierModel, ServerAcceptingData} from '../models/dossier.model';
import {RequestOptions, Response} from '@angular/http';
import {Appointments2Service} from '../../../appointments/services/appointments2.service';
import {Utilities} from '@shared/utilities/utilities.model';

import {WORKING_TYPE_CONFIGURATION, WorkingConfiguration} from '../models/working-configuration.model';
import {EsbContractModel} from '../models/esb-contract-model';
import {ClaimModel} from '../models/claim-model';
import {DossierHistoryListModel} from '../models/dossier-history-list.model';
import {VehicleEquipmentRequestModel} from '../models/vehicle-equipment.model';
import {VehicleAccessoriesRequestModel} from '../models/vehicle-accessories.model';
import {CommodityModel} from '@shared/models/commodity.model';
import {DossierAndWorkingStates, FileModel} from '../models/enums.model';
import {AttachmentsService} from './attachments.service';
import {of, Subject, Subscription, throwError} from 'rxjs';
import {MechanicWorkingItemsRequestModel} from '../models/mechanic-working-items.model';
import {AdministrationWorkingItemsRequestModel} from '../models/administration-working-items.model';
import {CarbodyWorkingItemsRequestModel} from '../models/carbody-working-items.model';
import {UploadFileService} from '@shared/service/upload-file.service';
import {FileManagerPollingService} from '@shared/service/file-manager-polling.service';
import {catchError, map, tap} from 'rxjs/operators';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {InnerMessageAuthorityMessageCode} from './inner-message-authority-utilities';
import {CommonMessageCode, MessageComponentType, MessageDetail, MessageType} from '@shared/service/message-manager/message.model';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import {AuthorityBaseService} from './authority-base.service';
import {ExportDossieDialogOutput} from '../components/au-export-dossie-csv/au-export-dossie-csv.component';
import {ClaimsPracticeModel} from '../../../claims/claims-practices/models/claims-practice.model';
import {PracticeModel} from '../models/practice-model';
import {PermissionService} from '@shared/service/permission.service';
import {AldDossierInnerNoteListResponse, AldDossierInnerNoteModel} from '../models/ald-dossier-inner-note.model';
import {QuotationsSyncErrorModel} from '../models/quotations-sync-error.model';
import { DateUtilities } from '@shared/utilities/date-utilities.model';
import { SnapshotList } from '../models/snapshot-list.model';
import { HTTPStatusCode } from '@shared/models/http-status-code.model';
import { ErrorResponse } from '@shared/models/error-response.model';
import { AuthorityUtilities } from '@authority/authority-shared/utilities/authority-utilities';


const jsonClaimsFile1: any = require('../../authority-sp/services/mock/jsonClaims1.json');
const jsonPracticesFile: any = require('../../authority-sp/services/mock/jsonPractices.json');
const jsonPracticesListFile: any = require('../../authority-sp/services/mock/jsonWorkingsPractice.json');

@Injectable()
export class DossiersService extends AuthorityBaseService implements ListService {

	dossierRefresher: Subject<void> = new Subject<void>(); // Serve a refreshare i dati del dossier
	downloadPaperSignaturePollingSubscription: Subscription;
	hasLoadedQuotation: Subject<{ working_id: string, loaded: boolean }> = new Subject<{ working_id: string; loaded: boolean }>();
	path_v1: string = ''

	constructor(protected injector: Injector,
				private selectCommoditiesService: SelectCommoditiesService,
				public appointmentService: Appointments2Service,
				public permissionsService: PermissionService,
				private attachmentsService: AttachmentsService,
				private uploadFileService: UploadFileService,
				private fileManagerPollingService: FileManagerPollingService) {
		super(injector);
		this.path_v1 = this.environment.AUTHORITY;
	}

	getCommodities(): string[] {
		return this.selectCommoditiesService.getCurrentCommodities().map(commodity => commodity.id);
	}

	// getBaseURL(dossier?: DossierModel): string {
	// 	return dossier && dossier.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
	// }
	getBaseURL(x?: boolean | DossierModel): string {
	// getBaseURL(x?: boolean | DossierModel | Object): string {

		if (Utilities.isEmpty(x) || x === false) {
			return this.environment.api.authority.v1;
		}

		if (x == true) {
			return this.environment.api.authority.historical.v1;
		}
		
		if (x instanceof DossierModel) {

			return x && x.isArchived && x.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
		}
		
		return this.environment.api.authority.v1;
		// return x && x.hasOwnProperty('archived') && x.archived == true ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
		// return x && x.archived && x.archived == true ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
	}

	// observable inutile, complica solo le cose
	getDossierRefresher(): Subject<void> {
		return this.dossierRefresher;
	}

	handleRequest<T>(type: {new(...args : any[]): T ;}): Function {

		const ctx = this;

		return function(url: string, http_options?: any): Observable<T>  {
			
			const options: RequestOptions = Utilities.nullish(http_options, Utilities.setOptionsWithNemoCommodityID(ctx.getCommodities()));
	
			return new Observable<T>(
				observer => {
					ctx.httpAuthService.get(url, ctx.redirectUrl, options).subscribe(
						res => {
							const content = res.json();
							if (res.status === 200) {
								try {
									observer.next(new type(content));
								} catch (err) {
									console.error(err);
									observer.error(err);
								}
							} else if ([404, 405, 500].includes(res.status)) {
								console.error(content);
								observer.next(content);
							} else {
								observer.next(null);
							}
						},
						err => {
							console.error(err);
							observer.error(err);
						}
					);
				}
			);
		}
	}

	getList(filter: OperationsFilterModel, params?: any): Observable<DossierList> {
		
		let url: string = this.environment.AUTHORITY_V3 + '/dossiers';

		if (filter) {
		
			// per sicurezza - to_archive va mandato solo negli stati indicati sotto
			filter.to_archive = null;
	
			// gli stati finti vengono sovrascritti con quelli veri e aggiunto il flag
			// if (filter.status === DossierAndWorkingStates.CLOSED_TO_BE_ARCHIVED) {
			// 	// da commento su JIRA
			// 	// Va lasciato solo to_archive=true quando si seleziona chiusi da archiviare
			// 	filter.status = null;
			// 	filter.to_archive = true;
			// }
			
			url = url + filter.getFilterUrl();
		}
		return this.handleRequest<DossierList>(DossierList)(url);
	}
	
	/**
	 * Archiviazione e performance
	 * recupera gli interventi archiviati
	 * 
	 * @param {OperationsFilterModel} filter
	 * @param {any} params?
	 * @returns {Observable<DossierList>}
	 */
	getListArchived(filter: OperationsFilterModel, params?: any): Observable<DossierList> {

		let url: string = this.environment.api.authority.historical.v3 + '/dossiers';
		if (filter) {

			// va filtrato perché a BE non esiste
			// if (filter.status === DossierAndWorkingStates.CLOSED_TO_BE_ARCHIVED) {
			// 	filter.status = DossierAndWorkingStates.CLOSED;
			// }
	
			// TODO
			// forse va fatta una forzatura sullo stato che dev'essere CLOSED
			url = url + filter.getFilterUrl();
		}
		return this.handleRequest<DossierList>(DossierList)(url);
	}

	getDossierById(
		dossierId: string, 
		isArchived: boolean, 
		onSuccess: (dossierModel: DossierModel) => void, 
		onFailure: (errorMessage: MessageDetail) => void
	): void {
		const url: string = (isArchived ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1) + '/dossiers/' + dossierId;
		
		// // TODO
		// // Modificare la funzione getCommoditiesFromItemMenuID()
		// // Le commodities andrebbero filtrare per modulo, e non per MenuID...
		// const module = (ModuleService.getCurrentModule() === Module.MOBILITY) ? UserV3Model.MOBILITY_ITEM_MENU_ID : UserV3Model.AUTHORITY_ITEM_MENU_ID;
		// const commodities: CommodityModel[] = this.permissionsService.getCommoditiesFromItemMenuID(module);

		// // TODO
		// // sostituire .forEach() + .push() con .map()...
		// const arrayCommodities: string[] = [];
		// commodities.forEach((commodity) => {
		// 	arrayCommodities.push(commodity.id);
		// });
		
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						onSuccess(new DossierModel(response.json()));
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					// onFailure({
					// 	type: MessageType.TYPE_ERROR,
					// 	code: CommonMessageCode.GENERIC_ERROR,
					// 	componentType: MessageComponentType.FLASH_MESSAGE
					// });
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getServerDossierAcceptance(dossierId: string): Observable<ServerAcceptingData> {
		// const url = `${this.environment.AUTHORITY}/dossiers/${dossierId}`;
		const url = `${this.getBaseURL()}/dossiers/${dossierId}`;
		return this.httpAuthService
			.get(url, this.redirectUrl, new RequestOptions())
			.pipe(map(response => (response.status === 200 && response && response.json() && response.json().accepting_data) || null));
	}

	updateDossierAcceptance( 
		dossier: DossierModel, 
		body: AcceptingDataRequestBody, 
		commodities: any,
		onSuccess: (response: Response) => void, 
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + '/dossiers/' + dossierId + '/accepting_data';
		const url = this.getBaseURL(dossier) + '/dossiers/' + dossier.id + '/accepting_data';

		// const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.patch(url, body, this.environment.ROOT_REDIRECT, options).subscribe(
			response => response.ok ? onSuccess(response) :
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response)),
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	getWorkingConfiguration(
		actives_only: boolean, 
		dossier: DossierModel, 
		onSuccess: (workingConfiguration: WorkingConfiguration, message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		let url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/workings/configuration`;
		const type: any = {actives_only: actives_only};
		url = url + Utilities.getQuery(type);
		const options: RequestOptions = new RequestOptions();
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						let commoditiesCheck: any;
						WORKING_TYPE_CONFIGURATION.forEach(workingType => commoditiesCheck = response.json().working_type_map[workingType].commodities);
						if (actives_only && !commoditiesCheck) {
							onFailure({
								code: InnerMessageAuthorityMessageCode.GATEWAY_1002,
								type: MessageType.TYPE_WARNING,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
							return;
						}
						onSuccess(new WorkingConfiguration(response.json()), MessageManagerUtilities.getMessageDetailsFromResponse(response));
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						code: CommonMessageCode.GENERIC_ERROR,
						type: MessageType.TYPE_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			});
	}

	searchContract(body: any, commodity: string, onSuccess: (response: any) => void, onFailure: (message: MessageDetail) => void): void {
		let url: string = this.environment.AUTHORITY + '/contracts';
		url = url + Utilities.getQuery(body);
		
		const options: any = Utilities.setOptionsWithNemoCommodityID([commodity]);

		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						const responseParsed: any = response.json();
						const esbContractModels: EsbContractModel[] = [];

						if (responseParsed.lenght) {
							responseParsed.forEach(el => {
								esbContractModels.push(new EsbContractModel(el));
							});
						} else {
							esbContractModels.push(new EsbContractModel(responseParsed));
						}

						onSuccess(esbContractModels);
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getClaimsByPlateAndChassis(plate: string, contract_id: string, chassis: string, page?: number, pageSize?: number, authority_workable: boolean = true, commodity?: string): Observable<{ claims: ClaimModel[], stats: any, message: MessageDetail }> {
		const body: any = {
			plate,
			...contract_id  && {contract_id},
			...chassis && {chassis},
			...page && pageSize && {page, page_size: pageSize},
			...!authority_workable && {authority_workable: authority_workable}
		};

		// const commodityList = !!commodity ? [commodity] : this.getCommodities();
		// const options: any = Utilities.setOptionsWithNemoCommodityID(commodityList);
		const options: any = Utilities.setOptionsWithNemoCommodityID([commodity]);
		
		const url: string = `${this.environment.AUTHORITY}/claims/${plate}${Utilities.getQuery(body)}`;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, !!commodity ? options : null).pipe(map(response => {
			if (response.ok) {
				try {
					const res: { items: any[], stats: any } = response.json();
					const claims: ClaimModel[] = res.items.map(claim => new ClaimModel(claim));
					return {
						claims,
						message: MessageManagerUtilities.getMessageDetailsFromResponse(response),
						stats: res.stats
					};
				} catch (error) {
					throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
				}
			} else {
				throw MessageManagerUtilities.getMessageDetailsFromResponse(new Error());
			}
		}), catchError(error => {
			throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
		}));
	}

	getClaimsByPlate(
		plate: string,
		chassis: string,
		onSuccess: (claims: ClaimModel[], message: MessageDetail, itemCount?: number, pageCount?: number) => void,
		onFailure: (message: MessageDetail) => void, page?: number, pageSize?: number,
	): void {
		if (this.environment.environment === 'selocal') {
			const jsonMock: any = jsonClaimsFile1;
			try {
				const claims: ClaimModel[] = [];
				jsonMock.items.forEach(claim => claims.push(claim));
				onSuccess(claims, MessageManagerUtilities.getMessageDetailsFromResponse(jsonMock));
			} catch (error) {
				onFailure({
					type: MessageType.TYPE_ERROR,
					code: CommonMessageCode.GENERIC_ERROR,
					componentType: MessageComponentType.FLASH_MESSAGE
				});
			}
		} else {
			let url: string = this.environment.AUTHORITY + '/claims';
			const body: any = {
				plate: plate,
				chassis: chassis
			};
			url = url + Utilities.getQuery(body);
			if (page && pageSize) {
				url += '&page=' + page + '&page_size=' + pageSize;
			}
			this.httpAuthService.get(url, this.redirectUrl).subscribe(
				response => {
					if (response.status === 200) {
						try {
							const claims: ClaimModel[] = [];
							let itemCount: number = 0;
							let pageCount: number = 0;
							response.json().items.forEach(claim => claims.push(new ClaimModel(claim)));
							itemCount = response.json().stats.item_count;
							pageCount = response.json().stats.page_count;
							if (itemCount && pageCount) {
								onSuccess(claims, MessageManagerUtilities.getMessageDetailsFromResponse(response), itemCount, pageCount);
							} else {
								onSuccess(claims, MessageManagerUtilities.getMessageDetailsFromResponse(response));
							}
						} catch (error) {
							onFailure({
								type: MessageType.TYPE_ERROR,
								code: CommonMessageCode.GENERIC_ERROR,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					} else {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				},
				error => {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				});
		}
	}

	getPracticesByPlate(plate: string, onSuccess: (practice: ClaimsPracticeModel[], message: MessageDetail) => void, onFailure: (message: MessageDetail) => void): void {
		this.environment = this.appConfig.Environment;
		if (this.environment.environment === 'local') {
			const jsonMock: any = jsonPracticesFile;
			try {
				const practices: ClaimsPracticeModel[] = [];
				jsonMock.items.forEach(practice => practices.push(practice));
				onSuccess(practices, MessageManagerUtilities.getMessageDetailsFromResponse(jsonMock));
			} catch (error) {
				onFailure({
					type: MessageType.TYPE_ERROR,
					code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
					componentType: MessageComponentType.FLASH_MESSAGE
				});
			}
		} else {
			const url: string = this.environment.AUTHORITY + '/claims/' + plate;
			this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
				response => {
					if (response.ok) {
						try {
							const practices: ClaimsPracticeModel[] = [];
							response.json().items.forEach(practice => practices.push(new ClaimsPracticeModel(practice)));
							onSuccess(practices, MessageManagerUtilities.getMessageDetailsFromResponse(response));
						} catch (error) {
							onFailure({
								type: MessageType.TYPE_ERROR,
								code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					} else {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				},
				error => {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				});
		}
	}

	createDossier(
		requestBody: CreateDossierRequestBody,
		commodity: string,
		onSuccess: (dossierId: string , dossierNumberPrefix: string, message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = this.environment.AUTHORITY + '/dossiers';
		const options: any = Utilities.setOptionsWithNemoCommodityID([commodity]);
		this.httpAuthService.post(url, requestBody, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						const dossierId: string = response.json().id;
						const dossierNumberPrefix: string = response.json().label;
						if (!Utilities.isVoid(dossierId)) {
							this.messageManagerService.deleteAll();
							onSuccess(dossierId, dossierNumberPrefix, {
								type: MessageType.TYPE_SUCCESS,
								code: InnerMessageAuthorityMessageCode.AUTHORITY_OPERATION_SAVED,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						} else {
							this.messageManagerService.deleteAll();
							onFailure({
								type: MessageType.TYPE_SUCCESS,
								code: InnerMessageAuthorityMessageCode.AUTHORITY_DOSSIER_NOT_SAVED,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					} catch (e) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	updateDossier(
		body: DossierModel,
		commodity: string[],
		onSuccess: (dossier: DossierModel, message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + body.id;
		// const options: any = Utilities.setOptionsWithNemoCommodityID(commodity);
		const options: any = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		this.httpAuthService.put(url, body, this.redirectUrl, options).subscribe(
			response => {
				if (response.status === 200) {
					try {
						onSuccess(new DossierModel(response.json()), MessageManagerUtilities.getMessageDetailsFromResponse(response));
					} catch (e) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.GENERIC_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			},
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	updatePriority(dossier: DossierModel, priority: string): Observable<Response> {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/priority`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/priority`;

		const requestBody: DossierRequestBody = {
			priority: priority,
		};
		return this.httpAuthService.patch(url, requestBody, this.redirectUrl);
	}

	getContractDossiersHistory(
		plate: string,
		isArchived: boolean,
		page: number,
		pageSize: number,
		onSuccess: (dossierList: DossierHistoryListModel) => void,
		onFailure?: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/history/${plate}?page=${page}&page_size=${pageSize}`;
		const url = `${this.getBaseURL(isArchived)}/dossiers/history/${plate}?page=${page}&page_size=${pageSize}`;

		this.httpAuthService.get(url, this.redirectUrl).subscribe((response: any) => {
			if (response.ok) {
				try {
					const responseBody: any = JSON.parse(response._body);
					onSuccess(new DossierHistoryListModel(responseBody));
				} catch (e) {
					onFailure({
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.GENERIC_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			} else {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
			}
		}, (error) => {
			onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
		});
	}

	addAttachment( 
		dossierId: string,
		commodities: CommodityModel[],
		file: FileModel,
		additionalRequestBody: any,
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/attachments`;
		const url = `${this.getBaseURL()}/dossiers/${dossierId}/attachments`;

		const params: { key: string, value: string }[] = [{
			key: 'blob_type',
			value: file.blob_type.toUpperCase()
		}, {key: 'thumbnail', value: 'true'}];
		this.attachmentsService.addAttachment(url, commodities, file, additionalRequestBody, onSuccess, onFailure, params);
	}

	addCloseAttachment( 
		dossierId: string,
		commodities: CommodityModel[],
		file: FileModel,
		additionalRequestBody: any,
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/close`;
		const url = `${this.getBaseURL()}/dossiers/${dossierId}/close`;

		this.attachmentsService.addCloseAttachment(url, commodities, file, additionalRequestBody, onSuccess, onFailure, []);
	}

	removeAttachments( 
		dossier: DossierModel,
		commodities: CommodityModel[],
		attachmentIds: string[],
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/attachments`;
		const url = `${this.getBaseURL(dossier)}/dossiers/${dossier.id}/attachments`;

		this.attachmentsService.removeAttachments(url, commodities, attachmentIds, onSuccess, onFailure, [{
			key: 'ids',
			value: attachmentIds.toString()
		}]);
	}

	downloadPaperSignature(data: any, id: string, type: 'acceptance' | 'redelivery', isToOtherCommodity: boolean = false): Observable<[Response, FileModel]> {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${id}/${type}_document${isToOtherCommodity ? '?to_other_center=true' : ''}`;
		return new Observable<[Response, FileModel]>(subscriber => {
			this.httpAuthService.post(url, data, this.redirectUrl).subscribe((res: Response) => {
				const obj: FileModel = res.json();
				if (res.ok && obj.uuid) {
					const file: FileModel = obj;
					const fileManagerId: string = file.uuid;
					this.fileManagerPollingService.settingPolling(fileManagerId, 6);
					const stopPolling: Function = () => {
						this.fileManagerPollingService.stopPolling();
						this.downloadPaperSignaturePollingSubscription.unsubscribe();
					};
					this.downloadPaperSignaturePollingSubscription = this.fileManagerPollingService.pollingObservable.subscribe(async (resp: any) => {
						if (resp && resp.id && resp.file_name) {
							stopPolling();
							this.uploadFileService.downloadAttachedFile(resp.id).subscribe((value: Response) => {
								subscriber.next([value, file]);
							}, error => subscriber.error(error));
						}
					}, error => {
						stopPolling();
						subscriber.error(new Error(`Errore durante il download in polling del documento ${fileManagerId}`));
					});
				} else {
					subscriber.error(new Error('Errore durante il download del documento'));
				}
			}, error => {
				subscriber.error(error);
			});
		});
	}

	getInterventionFileCsv(filter: ExportDossieDialogOutput): Observable<Response> {
		let url: string = this.environment.AUTHORITY + '/dossiers' + '/woe_document';
		url = url + Utilities.getQuery(filter);
		return this.httpAuthService.get(url, this.redirectUrl);
	}

	getPracticesListByPlate(plate: string, chassis: string, page?: number, pageSize?: number, types: string[] = [PracticeType.STAMP, PracticeType.TO_RE_REGISTER]): Observable<{ practices: PracticeModel[], stats: any, message: MessageDetail }> {
		const body: any = {
			...plate && {plate},
			...chassis && {chassis},
			...page && pageSize && {page, page_size: pageSize},
			...types && {types}
		};
		const url: string = `${this.environment.AUTHORITY}/carpractice/${plate}${Utilities.getQuery(body)}`;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).pipe(map(response => {
			if (response.ok) {
				try {
					const res: { items: any[], stats: any } = response.json();
					const practices: PracticeModel[] = res.items.map(practice => new PracticeModel(practice));
					return {
						practices,
						message: MessageManagerUtilities.getMessageDetailsFromResponse(response),
						stats: res.stats
					};
				} catch (error) {
					throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
				}
			} else {
				throw MessageManagerUtilities.getMessageDetailsFromResponse(new Error());
			}
		}), catchError(error => {
			throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
		}));

	}

	closeDossierById(dossier: DossierModel): Observable<Response> {
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/delivering`;
		return this.httpAuthService.patch(url, null, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	deleteDossier(dossier: DossierModel): Observable<Response> {
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}`;
		return this.httpAuthService.delete(url, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	getDossierNotesById(dossier: DossierModel): Observable<AldDossierInnerNoteListResponse> {
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/notes`;
		return this.httpAuthService.get(url, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json())
		);
	}

	saveDossierNote(dossier: DossierModel, note: AldDossierInnerNoteModel): Observable<{ id: string }> {  
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}`;
		return this.httpAuthService.post(url, note, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	updateDossierNote(dossier: DossierModel, note: AldDossierInnerNoteModel): Observable<any> {
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/notes/${note.id}`;
		return this.httpAuthService.put(url, note, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	deleteDossierNote(dossier: DossierModel, note: AldDossierInnerNoteModel): Observable<any> {
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/notes/${note.id}`;
		return this.httpAuthService.delete(url, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	getQuotationsSyncErrorsByDossierID(dossier: DossierModel): Observable<QuotationsSyncErrorModel> {

		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/quotations_refresh`;
		return this.httpAuthService.post(url, null, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}
	
	/*
	 *  1) nuova rotta per il tooltip riguardante i centri delle pratiche legate all’intervneto:
	 *  LISTA INTERVENTI
	 */ 

	getCommoditiesTooltip(dossier: DossierModel): Observable<CommodityTooltip[]> {
		const url: string = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/workings/commodities`;

		return new Observable<CommodityTooltip[]>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl).subscribe(
					res => {
						const content = res.json();
						if (!res.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content.data.map(x => new CommodityTooltip(x)));
						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
	}
	

	/*
	 *  2) nuova rotta per il tooltip riguardante la data creazione accettazione:
	 *  LISTA INTERVENTI
	 */ 

	getAcceptingData(dossier: DossierModel): Observable<AcceptingDataTooltip> {
		// let url: string = this.environment.AUTHORITY + `/dossiers/${dossier_id}/accepting_data`;
		const url = this.getBaseURL(dossier) + `/dossiers/${dossier.id}/accepting_data`;

		return new Observable<AcceptingDataTooltip>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl).subscribe(
					res => {
						try {
							const content = res.json();
							if (!res.ok) {
								observer.error(content);
								return;
							}
							observer.next(new AcceptingDataTooltip(content));
						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
	}

	
	/*
	 *  3) Per il recupero delle note da mostrare nel tool tip utilizzare l’endpoint:
	 *  utilizzando la stessa logica attualmente usata nel dettaglio intervento
	 *  LISTA INTERVENTI
	 */
	// TODO
	// forse questo è un duplicato di DossierGeneralNoteService.getDossierNoteList()
	getGeneralNotesTooltip(dossier_id: string): Observable<GeneralNotes[]> {
		let url: string = `${this.path_v1}/dossiers/${dossier_id}/general_notes`;

		return new Observable<GeneralNotes[]>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl).subscribe(
					res => {
						const content = res.json();
						if (!res.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content.items.map(x => new GeneralNotes(x)));
						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
	}

	/*
	 *  5) Recupera le informazioni del fornitore
	 *  LISTA PRATIChE
	 */
	getLogDossierInfoSupplierTooltip(id_commodity: string): Observable<CommodityModel> {
		let url: string = `${this.environment.PERMISSION_API}/commodities/${id_commodity}`;

		return new Observable<CommodityModel>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl).subscribe(
					res => {
						const content = res.json();
						if (!res.ok) {
							observer.error(content);
							return;
						}
						try {
							// observer.next(content.items);
							observer.next(new CommodityModel(content));
						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
	}

	getDossierAttachment(dossier_id: string): Observable<DossierAttachment> {
		let url: string = `${this.environment.AUTHORITY_V2}/dossiers/${dossier_id}/download`;
		return new Observable<DossierAttachment>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
					res => {

						let content;

						try {
							content = res.json();
						} catch (err) {
							console.error(err);
							observer.error(err);
							observer.next(null);
						}

						if (res.status === HTTPStatusCode[200]) {
							try {
								observer.next(new DossierAttachment(content));
							} catch (err) {
								console.error(err);
								observer.error(err);
							}
						} else {
							const err = new ErrorResponse(res);
							if (err.hasStatusCode([HTTPStatusCode[404], HTTPStatusCode[500]])) {
								console.error(err);
								observer.error(err);
							}								
							observer.next(null);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
		});
	}

}

interface DossierRequestBody {
	priority: string;
}

export interface CreateDossierRequestBody {
	contract_id: string;
	customer_id: string;
	driver_id: string;
	plate: string;
	appointment_id?: string;
}

export interface AcceptingDataRequestBody {
	accepting_km: string;
	car_shape: any;
	ddt_number: string;
	email: string;
	expected_delivery_date: string;
	first_name: string;
	fuel_level: string;
	last_name: string;
	phone: string;
	rescue_company: string;
	truck_plate: string;
	carbody_note: string;
	saddlery_note: string;
	carbody_working_items: CarbodyWorkingItemsRequestModel;
	administration_working_items: AdministrationWorkingItemsRequestModel;
	mechanic_working_items: MechanicWorkingItemsRequestModel;
	vehicle_equipment: VehicleEquipmentRequestModel;
	vehicle_accessories: VehicleAccessoriesRequestModel;
	tires_wear_level: number;
	fiscal_code: string;
	replacement_vehicle_plate: string;
	is_suspended_technical_stop?: boolean;
}

export interface HistoryQueryParams {
	plate: string;
	dossierNumberPrefix: string;
	dossierId: string;
	is_archived: boolean;
}

export enum PracticeType {
	TO_RE_REGISTER = 'TO_RE_REGISTER',
	STAMP = 'STAMP'
}

class Comm extends CommodityModel {
	
	flag_service_point: boolean = false;
	disable_at: 				string = '';
	
	constructor(model?: any) {
		super();
		
		if (Utilities.isEmpty(model)) {
			return;
		}
		
		Object.assign(this, model);
	}
}

export class CommodityTooltip {

	type 								  : string = ''; // "CARBODY"
	working_number_prefix : string = ''; // "NEM1234";
	commodity 						: Comm;
	
	constructor(model?: any) {
		
		if (Utilities.isEmpty(model)) {
			return;
		}

		this.type 								 = model.type;
		this.working_number_prefix = model.working_number_prefix;
		this.commodity 						 = new Comm(model.commodity);
	}
}

export class AcceptingDataTooltip {
	first_name									 : string = '';
	last_name										 : string = '';
	email												 : string = '';
	phone												 : string = '';
	accepting_km								 : string = '';
	fuel_level									 : string = '';
	truck_plate									 : string = '';
	rescue_company							 : string = '';
	ddt_number									 : string = '';
	expected_delivery_date			 : string = ''; //'2023-09-27';
	car_shape										 : object = {};
	carbody_working_items				 : object = {};
	administration_working_items : object = {};
	mechanic_working_items			 : object = {};
	vehicle_equipment						 : object = {};
	vehicle_accessories					 : object = {};
	carbody_note								 : string = '';
	saddlery_note								 : string = '';
	tires_wear_level						 : number = 0;
	replacement_vehicle_plate		 : string = '';
	fiscal_code									 : string = '';
	created_at									 : string = ''; //1695812577017;

	constructor(model?: any) {
		
		if (Utilities.isEmpty(model)) {
			return;
		}

		Object.assign(this, model);

		this.expected_delivery_date = DateUtilities.getUTCStringFromDate(model.expected_delivery_date);
		this.created_at             = DateUtilities.getUTCStringFromDate(model.created_at);
	}
}

export class GeneralNotes {
	id										: string;
	user_id								: string;
	user_label						: string;
	reference_id					: string;
	reference_type				: string;
	reference_source			: string;
	reference_priority		: string;
	reference_description	: string;
	note_text							: string;
	created_at						: string;
	updated_at						: string;

	constructor(model?: any) {
		
		if (Utilities.isEmpty(model)) {
			return;
		}

		Object.assign(this, model);
	}
}